export const instagramPositions = ['story', 'reels', 'ig_search', 'profile_reels']
